(function () {
  // THEME-ADR-005 (addendum 2026-08-06) — PDP / quick-buy "Notify me when available".
  // Dual path:
  //   1) Soft commerce session → POST /v1/stock-alerts via ErosCommerce (session JWT).
  //   2) Guest fallback → Shopify /contact + localStorage (no worker secrets / App Check).
  // Soft gate: CTA → if no session, eros-account-auth sheet → after OTP, subscribe.
  // Prestige replaces <buy-buttons> on variant change — use event delegation.
  var STORAGE_KEY = 'eros_stock_notify_intents_v1';
  var MAX_INTENTS = 50;
  var bound = false;

  function strings() {
    return window.ErosStockNotifyStrings || {};
  }

  function toast(message, kind) {
    if (window.ErosUI && typeof window.ErosUI.toast === 'function') {
      window.ErosUI.toast(message, kind || 'success');
      return;
    }
    window.alert(message);
  }

  function hasCommerceSession() {
    return !!(
      window.ErosSession &&
      typeof window.ErosSession.isSignedIn === 'function' &&
      window.ErosSession.isSignedIn() &&
      window.ErosCommerce &&
      typeof window.ErosCommerce.request === 'function'
    );
  }

  function canSoftGate() {
    return !!(
      window.ErosUI &&
      typeof window.ErosUI.openSheet === 'function' &&
      window.ErosAccountAuth &&
      window.ErosSession &&
      typeof window.ErosSession.onChange === 'function' &&
      window.ErosCommerce
    );
  }

  function readIntents() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeIntents(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_INTENTS)));
    } catch (e) {
      // Storage full/disabled — contact POST / mailto still available.
    }
  }

  function storeIntent(root, email, phone, channel) {
    var list = readIntents().filter(function (item) {
      return !(item.variantId === root.dataset.variantId && item.email === email);
    });
    list.unshift({
      email: email || '',
      phone: phone || '',
      productHandle: root.dataset.productHandle || '',
      variantId: root.dataset.variantId || '',
      variantGid: variantGid(root),
      productTitle: root.dataset.productTitle || '',
      variantTitle: root.dataset.variantTitle || '',
      createdAt: Date.now(),
      channel: channel || 'theme-contact-form',
    });
    writeIntents(list);
  }

  function variantGid(root) {
    var gid = (root.dataset.variantGid || '').trim();
    if (gid) return gid;
    var id = (root.dataset.variantId || '').trim();
    return id ? 'gid://shopify/ProductVariant/' + id : '';
  }

  function resolveLocale(root) {
    var fromData = (root.dataset.locale || '').trim();
    if (fromData) return fromData;
    if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale);
    return 'ar';
  }

  /*
   * Owner-reported 2026-08-09: clicking the CTA worked (subscribed
   * server-side / stored the intent) but the button itself never visibly
   * changed — only a transient toast appeared, giving the customer no
   * lasting confirmation an action was taken. Swap the CTA into a
   * persistent "subscribed" state (label + icon + disabled) so the button
   * itself is the confirmation, not just a toast that fades.
   */
  var CHECK_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function ctaLabelEl(cta) {
    return cta.querySelector('.eros-stock-notify__cta-inner span:last-child');
  }

  // Subscribed state is now a TOGGLE (owner 2026-08-29): it stays enabled and,
  // when tapped again, CANCELS the alert (mirrors the Flutter subscribed chip +
  // the account grid's unsubscribe). The checkmark + "tap to cancel" label make
  // the active/subscribed state legible.
  function setSubscribedState(root) {
    var s = strings();
    var cta = root.querySelector('[data-eros-stock-notify-cta]');
    if (!cta) return;
    cta.classList.add('is-subscribed');
    cta.disabled = false;
    cta.setAttribute('aria-pressed', 'true');
    var label = ctaLabelEl(cta);
    if (label) label.textContent = s.subscribed_active || 'Subscribed — tap to cancel';
    var icon = cta.querySelector('svg');
    if (icon) {
      if (!cta.dataset.iconOriginal) cta.dataset.iconOriginal = icon.outerHTML;
      icon.outerHTML = CHECK_SVG;
    }
  }

  function setUnsubscribedState(root) {
    var s = strings();
    var cta = root.querySelector('[data-eros-stock-notify-cta]');
    if (!cta) return;
    cta.classList.remove('is-subscribed');
    cta.disabled = false;
    cta.setAttribute('aria-pressed', 'false');
    var label = ctaLabelEl(cta);
    if (label) label.textContent = s.cta || 'Notify me when available';
    var icon = cta.querySelector('svg');
    if (icon && cta.dataset.iconOriginal) icon.outerHTML = cta.dataset.iconOriginal;
  }

  function removeIntent(root) {
    var vid = root.dataset.variantId || '';
    writeIntents(
      readIntents().filter(function (it) {
        return it.variantId !== vid;
      })
    );
  }

  async function doCancel(root) {
    var s = strings();
    var cta = root.querySelector('[data-eros-stock-notify-cta]');
    if (cta) cta.disabled = true; // guard double-tap during the request
    try {
      if (hasCommerceSession()) {
        var gid = variantGid(root);
        if (gid) {
          await window.ErosCommerce.request('/v1/stock-alerts/' + encodeURIComponent(gid), {
            method: 'DELETE',
            auth: true,
          });
        }
      }
      removeIntent(root);
      setUnsubscribedState(root);
      toast(s.unsubscribed || 'Alert cancelled.', 'success');
    } catch (e) {
      if (cta) cta.disabled = false;
      toast(s.error || 'Something went wrong, please try again', 'error');
    }
  }

  function setPanelOpen(root, open) {
    var panel = root.querySelector('[data-eros-stock-notify-panel]');
    var cta = root.querySelector('[data-eros-stock-notify-cta]');
    if (!panel || !cta) return;
    panel.hidden = !open;
    cta.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var email = root.querySelector('[data-eros-stock-notify-email]');
      if (email) window.setTimeout(function () { email.focus(); }, 50);
    }
  }

  async function submitContact(root, email, phone) {
    var body = new FormData();
    body.append('form_type', 'contact');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    if (phone) body.append('contact[phone]', phone);
    body.append('contact[tags]', 'stock-alert,' + (root.dataset.productHandle || ''));
    body.append(
      'contact[body]',
      root.dataset.notifyBody ||
        ('Back-in-stock request: ' + (root.dataset.productTitle || '') + ' / variant ' + (root.dataset.variantId || ''))
    );

    var response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') + 'contact', {
      method: 'POST',
      body: body,
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('contact_failed');
  }

  async function subscribeViaWorker(root) {
    var gid = variantGid(root);
    var handle = (root.dataset.productHandle || '').trim();
    if (!gid || !handle) throw new Error('invalid_payload');
    return window.ErosCommerce.request('/v1/stock-alerts', {
      method: 'POST',
      auth: true,
      body: {
        variantGid: gid,
        productHandle: handle,
        locale: resolveLocale(root),
      },
    });
  }

  async function doWorkerSubscribe(root) {
    var s = strings();
    try {
      await subscribeViaWorker(root);
      storeIntent(root, '', '', 'theme-commerce-session');
      setSubscribedState(root);
      // Web push intent moment (ADR-172): an alert only helps if it can reach her.
      try { document.dispatchEvent(new CustomEvent('eros:web-push-moment', { detail: { source: 'stock_alert' } })); } catch (e) { /* ignore */ }
      toast(s.subscribed || "We'll notify you when the product is back in stock.", 'success');
    } catch (e) {
      toast(s.error || 'Something went wrong, please try again', 'error');
    }
  }

  function openAuthThenSubscribe(root) {
    var s = strings();
    var completed = false;
    var wrap = window.ErosUI.el('div');
    var prompt = window.ErosUI.el('p', 'text-subdued');
    prompt.textContent =
      s.signInRequired || 'Sign in to get notified when this item is back.';
    wrap.appendChild(prompt);
    var panel = window.ErosUI.el('div', '', { 'data-eros-auth-panel': '' });
    wrap.appendChild(panel);

    var unsubscribe = null;
    var sheet = window.ErosUI.openSheet({
      title: s.cta || 'Notify me when available',
      content: wrap,
      onClose: function () {
        // A gate closed without signing in must stop listening — otherwise
        // a later sign-in silently armed this product's alert (audit
        // 2026-09-13).
        if (unsubscribe) unsubscribe();
        unsubscribe = null;
        if (!completed) {
          // Guest fallback — contact form + localStorage (THEME-ADR-005 dual path).
          setPanelOpen(root, true);
        }
      },
    });
    if (window.ErosAccountAuth) window.ErosAccountAuth.mountAll();

    unsubscribe = window.ErosSession.onChange(function (session) {
      if (session && session.customerGid) {
        completed = true;
        if (unsubscribe) unsubscribe();
        unsubscribe = null;
        sheet.close();
        doWorkerSubscribe(root);
      }
    });
  }

  function onNotifyCta(root) {
    var cta = root.querySelector('[data-eros-stock-notify-cta]');
    if (cta && cta.classList.contains('is-subscribed')) {
      // Second tap on an active alert cancels the subscription.
      doCancel(root);
      return;
    }
    if (hasCommerceSession()) {
      doWorkerSubscribe(root);
      return;
    }
    if (canSoftGate()) {
      openAuthThenSubscribe(root);
      return;
    }
    // No commerce bridge loaded — guest panel only.
    var panel = root.querySelector('[data-eros-stock-notify-panel]');
    setPanelOpen(root, !!(panel && panel.hidden));
  }

  function onDocumentClick(event) {
    var cta = event.target.closest('[data-eros-stock-notify-cta]');
    if (cta) {
      var root = cta.closest('[data-eros-stock-notify]');
      if (!root) return;
      event.preventDefault();
      onNotifyCta(root);
      return;
    }

    var submit = event.target.closest('[data-eros-stock-notify-submit]');
    if (!submit) return;
    var notifyRoot = submit.closest('[data-eros-stock-notify]');
    if (!notifyRoot) return;
    event.preventDefault();
    handleGuestSubmit(notifyRoot, submit);
  }

  async function handleGuestSubmit(root, submitBtn) {
    var emailInput = root.querySelector('[data-eros-stock-notify-email]');
    var phoneInput = root.querySelector('[data-eros-stock-notify-phone]');
    var email = emailInput ? String(emailInput.value || '').trim() : '';
    var phone = phoneInput ? String(phoneInput.value || '').trim() : '';
    var s = strings();

    if (!email || email.indexOf('@') === -1) {
      toast(s.validation || 'Enter a valid email.', 'error');
      if (emailInput) emailInput.focus();
      return;
    }

    submitBtn.disabled = true;
    storeIntent(root, email, phone, 'theme-contact-form');

    try {
      await submitContact(root, email, phone);
    } catch (e) {
      // Contact may fail in theme preview / offline — intent is stored; mailto remains.
    }

    setPanelOpen(root, false);
    setSubscribedState(root);
    toast(s.subscribed || "We'll notify you when the product is back in stock.", 'success');
    submitBtn.disabled = false;
  }

  // Reflect an EXISTING subscription on load (owner 2026-08-29): after a
  // refresh / re-visit the PDP must already show the subscribed toggle if the
  // customer is signed up for this variant — otherwise it looks un-subscribed
  // even though the account "notify when available" list has it. Server is the
  // source of truth for signed-in customers (covers a fresh device / cleared
  // localStorage); guests fall back to the stored local intent.
  function markSubscribedFromLocal(root) {
    var vid = root.dataset.variantId || '';
    if (readIntents().some(function (it) { return it.variantId === vid; })) {
      setSubscribedState(root);
    }
  }

  async function hydrateAllFromWorker(roots) {
    try {
      var res = await window.ErosCommerce.request('/v1/stock-alerts', { auth: true });
      var list = (res && (res.alerts || res.data || res.stockAlerts)) || res || [];
      if (!Array.isArray(list)) list = [];
      var gids = {};
      list.forEach(function (a) { if (a && a.variantGid) gids[a.variantGid] = 1; });
      roots.forEach(function (root) {
        if (gids[variantGid(root)]) setSubscribedState(root);
        else markSubscribedFromLocal(root);
      });
    } catch (e) {
      roots.forEach(markSubscribedFromLocal);
    }
  }

  function hydrate() {
    var roots = document.querySelectorAll('[data-eros-stock-notify]');
    if (!roots.length) return;
    if (hasCommerceSession()) {
      hydrateAllFromWorker(roots);
    } else {
      roots.forEach(markSubscribedFromLocal);
    }
  }

  function bind() {
    if (bound) return;
    bound = true;
    document.addEventListener('click', onDocumentClick);
    hydrate();
    // Re-hydrate once the commerce session resolves (it can load after this
    // script) so a signed-in customer's existing alert shows without a manual
    // refresh.
    if (window.ErosSession && typeof window.ErosSession.onChange === 'function') {
      window.ErosSession.onChange(function () { hydrate(); });
    }
    // theme.js swaps the whole <buy-buttons> block on a variant change, and
    // this button is rendered inside it — the new markup knows nothing of an
    // existing alert until re-hydrated (audit 2026-09-13). The event bubbles
    // from the product form; the swap lands after it, hence the tick.
    document.addEventListener('variant:change', function () { setTimeout(hydrate, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
